<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()"><ion-icon slot="start" name="close"></ion-icon></ion-button>
    </ion-buttons>
    <ion-title clas="ion-text-center">QR Code</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
<div>
  <div class="qr-container" [innerHTML]="svgSave" style="">
</div>
  <h3 class="ion-text-center">{{ code }}</h3>
</div>
</ion-content>
